import { useEffect } from 'react';
import { useQuery } from 'react-apollo';
import useAuth from '@jetshop/core/components/AuthContext/useAuth';
import { useElevate } from './ElevateContext';
import customerIdQuery from './CustomerIdQuery.gql';
import { fetchVoyadoDiscoveryKey } from './fetchVoyadoDiscoveryKey';
import { logElevateCustomerKey } from './elevateCustomerKeyLog';

export const ElevateCustomerHandler = () => {
  const { updateCustomerKey, getCustomerKey } = useElevate();
  const { loggedIn } = useAuth();
  const { data, loading } = useQuery(customerIdQuery, {
    skip: !loggedIn,
    errorPolicy: 'ignore',
    fetchPolicy: 'no-cache'
  });

  const externalId = data?.customer?.externalId;
  useEffect(() => {
    if (!loggedIn || loading || !externalId) return;

    let cancelled = false;
    const clientCustomerKey = getCustomerKey();

    logElevateCustomerKey('login sync started', {
      externalId,
      clientCustomerKey
    });

    fetchVoyadoDiscoveryKey(externalId, clientCustomerKey).then(discoveryKey => {
      if (cancelled) return;

      if (discoveryKey) {
        logElevateCustomerKey('login sync resolved', {
          externalId,
          discoveryKey,
          clientCustomerKey,
          willUpdate: discoveryKey !== clientCustomerKey
        });
        updateCustomerKey(discoveryKey);
      } else {
        logElevateCustomerKey('login sync failed — no discoveryKey', {
          externalId,
          clientCustomerKey
        });
      }
    });

    return () => {
      cancelled = true;
    };
  }, [loggedIn, externalId, loading, getCustomerKey, updateCustomerKey]);

  return null;
};
